const RegionOptions = Object.freeze({
  WORLD: 'World',
  NORTH_AMERICA: 'NorthAmerica',
  US: 'US',
  CANADA: 'Canada',
  MEXICO: 'Mexico',
  SOUTH_AMERICA: 'SouthAmerica',
  BRAZIL: 'Brazil',
  CENTRAL_AMERICA: 'CentralAmerica',
  EUROPE: 'Europe',
  UNITED_KINGDOM: 'UnitedKingdom',
  GERMANY: 'Germany',
  FRANCE: 'France',
  POLAND: 'Poland',
  SPAIN: 'Spain',
  ITALY: 'Italy',
  RUSSIA: 'Russia',
  TURKEY: 'Turkey',
  AFRICA: 'Africa',
  ASIA: 'Asia',
  INDIA: 'India',
  CHINA: 'China',
  SOUTH_KOREA: 'SouthKorea',
  JAPAN: 'Japan',
  INDONESIA: 'Indonesia',
  THAILAND: 'Thailand',
  MALAYSIA: 'Malaysia',
  OCEANIA: 'Oceania',
  AUSTRALIA: 'Australia',
  NEW_ZEALAND: 'NewZealand',
  CARIBBEAN: 'Caribbean'
})
export default RegionOptions
export type RegionOptionsStrings = typeof RegionOptions[keyof typeof RegionOptions]
// RESERVE BELOW
